import { RecordBase, registerInflection } from 'lib/record-base';
import moment from 'moment';

export class HabitSetting extends RecordBase {
    static NAME = 'HabitSetting';
    static ASSOCS = {
        habit: { type: 'belongsTo' },
        user: { type: 'belongsTo' }
    }

    endMoment() {
        return this.endDate ? moment(this.endDate) : moment().add(9999,'days');
    }

    isCurrent() {
        return moment().isSameOrBefore(this.endMoment());
    }

}

registerInflection('habitSetting','habitSettings',HabitSetting);
